import {eventsDataFlow} from "../constants/eventsDataFlow";

export const getEventDataFlow = (group, action, configs) => eventsDataFlow?.[group]?.[action]?.(configs) ?? {}
